var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<p>Please confirm your desire to delete{{$ctrl.request.name}} (#{{$ctrl.request.id}})?</p>";
var id1="retailer-shipping-location-delete-confirmation.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;